/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crimson_Brave_Otter_WhisperInputs */

const en_crimson_brave_otter_whisper = /** @type {(inputs: Crimson_Brave_Otter_WhisperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers`)
};

const de_crimson_brave_otter_whisper = /** @type {(inputs: Crimson_Brave_Otter_WhisperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten`)
};

/**
* | output |
* | --- |
* | "Answers" |
*
* @param {Crimson_Brave_Otter_WhisperInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const crimson_brave_otter_whisper = /** @type {((inputs?: Crimson_Brave_Otter_WhisperInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crimson_Brave_Otter_WhisperInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crimson_brave_otter_whisper(inputs)
	return de_crimson_brave_otter_whisper(inputs)
});